// NOVALUE1 (docs/build-briefs/NOVALUE1-no-na-no-utc.md; design/style-guide.md, "Blank, never N/A"): a few server answers still
// carry the word "N/A" as a placeholder (the royalty statement's rate text is one). The screen never prints it: this is the one
// place the word appears in the UI sources, and it is only compared, never shown.

/** The placeholder some server answers carry for "no value". Compared, never rendered. */
const SERVER_PLACEHOLDER = "N/A";

/** A server value as a person reads it: the placeholder becomes a dash, every other value is unchanged. */
export function fromServer(text: string): string {
  return text === SERVER_PLACEHOLDER ? "-" : text;
}
